import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import Button from 'components/crm/ui/Button';
import IconButton from 'components/crm/ui/IconButton';
import TextField from 'components/crm/ui/TextField';
import PhoneField from 'components/prospection/PhoneField';
import useText from 'hooks/useText';

const EMPTY_CONTACT = { name: '', position: '', phone: '', email: '' };

// A stable key per card: an index key would hand a removed card's PhoneField
// state (left or not) to the card that takes its place. Never sent to the api.
let nextContactKey = 0;

const ProspectContacts = ({ contacts, onChange }) => {
  const { text } = useText('prospection.addProspect.contacts');

  const update = (index, key, value) =>
    onChange(
      contacts.map((contact, i) =>
        i === index ? { ...contact, [key]: value } : contact,
      ),
    );

  return (
    <section className="flex flex-col gap-3">
      <h3 className="flex items-baseline gap-2 text-sm font-semibold text-ink">
        {text('title')}
        <span className="text-xs font-normal text-faint">
          {text('optional')}
        </span>
      </h3>
      {contacts.map((contact, index) => (
        <div
          key={contact.key ?? index}
          className="flex flex-col gap-3 rounded-lg border border-line p-4"
        >
          <div className="flex items-center justify-between">
            <span className="text-sm font-semibold text-ink">
              {text('card', { n: index + 1 })}
            </span>
            <IconButton
              icon={Trash2}
              label={text('remove')}
              onClick={() => onChange(contacts.filter((_, i) => i !== index))}
            />
          </div>
          <TextField
            id={`prospect-contact-name-${index}`}
            label={text('name')}
            value={contact.name}
            onChange={(event) => update(index, 'name', event.target.value)}
          />
          <TextField
            id={`prospect-contact-position-${index}`}
            label={text('position')}
            value={contact.position}
            onChange={(event) => update(index, 'position', event.target.value)}
          />
          <PhoneField
            id={`prospect-contact-phone-${index}`}
            label={text('phone')}
            value={contact.phone}
            onChange={(value) => update(index, 'phone', value)}
          />
          <TextField
            id={`prospect-contact-email-${index}`}
            label={text('email')}
            type="email"
            placeholder={text('emailPlaceholder')}
            helper={index === 0 ? text('adminHint') : undefined}
            value={contact.email}
            onChange={(event) => update(index, 'email', event.target.value)}
          />
        </div>
      ))}
      <div>
        <Button
          variant="secondary"
          icon={Plus}
          onClick={() => {
            nextContactKey += 1;
            onChange([...contacts, { ...EMPTY_CONTACT, key: nextContactKey }]);
          }}
        >
          {contacts.length ? text('addAnother') : text('add')}
        </Button>
      </div>
    </section>
  );
};

export default ProspectContacts;
